export default __webpack_public_path__ + "images/44521f4daa65a77fc0b2b1dabd93e8e8-ticketing_sp1_2@2x.png";